const apiUrl = window.GlobalConfig.REACT_APP_BASE_URL;

export const appConfig = {
  apiUrl,
};
